import { render, staticRenderFns } from "./PalletHeader.vue?vue&type=template&id=72b589b6&scoped=true"
import script from "./PalletHeader.vue?vue&type=script&lang=ts"
export * from "./PalletHeader.vue?vue&type=script&lang=ts"
import style0 from "./PalletHeader.vue?vue&type=style&index=0&id=72b589b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b589b6",
  null
  
)

export default component.exports